import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "overlay", "panel"]
  static values = { open: Boolean }

  connect() {
    this.openValue = false
    this.sync()
  }

  toggle(event) {
    event.preventDefault()
    this.openValue = !this.openValue
  }

  hide(event) {
    if (!this.mobileViewport()) return
    if (event && this.clickInsideSidebar(event.target)) return

    this.openValue = false
  }

  hideOnNavigate() {
    this.openValue = false
  }

  openValueChanged() {
    this.sync()
  }

  sync() {
    this.panelTarget.classList.toggle("-translate-x-full", !this.openValue)
    this.panelTarget.classList.toggle("translate-x-0", this.openValue)
    this.overlayTarget.classList.toggle("opacity-0", !this.openValue)
    this.overlayTarget.classList.toggle("opacity-100", this.openValue)
    this.overlayTarget.classList.toggle("pointer-events-none", !this.openValue)
    this.overlayTarget.classList.toggle("pointer-events-auto", this.openValue)
  }

  clickInsideSidebar(target) {
    return this.panelTarget.contains(target) || this.buttonTarget.contains(target)
  }

  mobileViewport() {
    return window.matchMedia("(max-width: 767px)").matches
  }
}
